import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../../app/services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ItemResponse } from "@rubii/frontend-common/lib/models/common/Response";
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-quantcast',
  templateUrl: './quantcast.component.html',
  styleUrls: ['./quantcast.component.scss']
})
export class QuantcastComponent extends BaseDatasourceComponent implements OnInit {

  quantcastStep = 1;

  constructor(private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.connectionForm = new FormGroup({
      apiKey: new FormControl('', [Validators.required]),
      apiSecret: new FormControl('', [Validators.required])
    });
  }

  connect() {
    if (this.connectionForm.valid) {
      this.client.account.saveQuantcastConfig(this.connectionForm.value).then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
          this.dialogRef.close();
      }).catch(e => this.openSnackBarWarning(this.snackBar, e.message, 'closed'));
    }
  }
}
